<template>
    <div v-if="length" class="io-pagination">
        <button
            class="page-item"
            :disabled="currentPage <= 1"
            @click="changePage(1)"
            type="button"
        >
            <span>«</span>
        </button>
        <button
            class="page-item"
            :disabled="currentPage <= 1"
            @click="changePage(--activePage)"
            type="button"
        >
            <span>‹</span>
        </button>
        <div class="io-pagination-page-selection">
            <button
                v-for="page in pageRange"
                :key="page"
                :class="['page-item', page === activePage ? 'active' : '' ]"
                @click="changePage(page)"
                type="button"
            >
                <span>{{ page }}</span>
            </button>
        </div>
        <button
            class="page-item"
            :disabled="currentPage >= length"
            @click="changePage(++activePage)"
            type="button"
        >
            <span>›</span>
        </button>
        <button
            class="page-item"
            :disabled="currentPage >= length"
            @click="changePage(length)"
            type="button"
        >
            <span>»</span>
        </button>
    </div>
</template>

<script>
export default {
  name: 'IoPagination',
  data() {
    return {
      activePage: this.currentPage,
      pages: this.maxPages,
    };
  },
  props: {
    currentPage: {
      required: true,
      type: Number,
    },
    length: {
      type: Number,
      default: 1,
    },
    maxPages: {
      type: Number,
      default: 5,
    },
  },
  watch: {
    currentPage() {
      this.activePage = this.currentPage;
    },
  },
  computed: {
    pageRange() {
      this.length < this.maxPages ? this.pages = this.length : this.pages = this.maxPages;
      const middleRangeMod = Math.floor(this.maxPages / 2);

      // ensure activePage isn't out of range
      this.activePage < 1
        ? this.activePage = 1
        : this.activePage > this.length
          ? this.activePage = this.length
          : '';

      const rangeStart = this.activePage <= middleRangeMod || this.length < this.maxPages
        ? 1
        : this.activePage > this.length - middleRangeMod
          ? this.length - middleRangeMod * 2
          : this.activePage - middleRangeMod;
      const size = this.pages > this.length ? this.length : this.pages;

      return this.range(size, rangeStart);
    },
  },
  methods: {
    changePage(payload) {
      this.activePage = payload;
      this.$emit('change', payload);
    },
    range(size, startAt = 0) {
      return [...Array(size).keys()].map((i) => i + startAt);
    },
  },
};
</script>

<style lang="scss" scoped>
.io-pagination,
.io-pagination-page-selection {
    display: flex;
    justify-content: flex-end;

    .page-item {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color .15s;

        width: 2rem;
        height: 2.4rem;

        border: none;
        background-color: transparent;
        color: #212529;

        &:hover {
            background-color: #e9ecef;
        }

        &.active {
            font-weight: 700;
            color: #000;
        }

        &:disabled {
            color: #ababab;
        }
    }
}
</style>
